import { OpenGovAppConfig } from '@opengov/app-config';
import { IStory, IStoryCustomColors, IUser } from '@opengov/stories-shared/types';

import { ICustomColor, IGetStoryGraphqlResponse, IStoryListing } from '../../types';

export const processCustomColors = (customColors: ICustomColor[]) => {
  return {
    header: {
      background: customColors.find(
        (customColor) => customColor.contentType === 'header' && customColor.colorTarget === 'background'
      ).colors,
      font: customColors.find(
        (customColor) => customColor.contentType === 'header' && customColor.colorTarget === 'font'
      ).colors
    },
    body_content: {
      background: customColors.find(
        (customColor) => customColor.contentType === 'body_content' && customColor.colorTarget === 'background'
      ).colors,
      font: customColors.find(
        (customColor) => customColor.contentType === 'body_content' && customColor.colorTarget === 'font'
      ).colors
    },
    footer: {
      background: customColors.find(
        (customColor) => customColor.contentType === 'footer' && customColor.colorTarget === 'background'
      ).colors,
      font: customColors.find(
        (customColor) => customColor.contentType === 'footer' && customColor.colorTarget === 'font'
      ).colors
    }
  } as IStoryCustomColors;
};

export const processStoryOrTemplate = (data: IGetStoryGraphqlResponse): IStory => {
  return {
    _id: data._id,
    createdAt: data.createdAt,
    createdBy: data.createdBy || data.authorId,
    entity_id: data.entityId,
    folderId: data.folderId,
    state: data.state,
    story_key: data.storyKey,
    title: data.title,
    updatedAt: data.updatedAt,
    updatedBy: data.updatedBy,
    visibility: data.visibility,
    description: data.description,
    publishedAt: data.publishedAt,
    publishedBy: data.publishedBy,
    thumbnail: data.thumbnail,
    public_url: data.publicUrl,
    thumbnail_relative_path: data.thumbnailRelativePath,
    paddingTop: data.paddingTop,
    paddingBottom: data.paddingBottom,
    customCssCode: data.customCssCode,
    isFollowable: data.isFollowable || false,
    meta: {
      customColors:
        data.customColors && Object.keys(data.customColors).length !== 0 ? processCustomColors(data.customColors) : {}
    },
    author: data.author
      ? ({
          _id: data.author._id,
          email: data.author.email,
          name: { first: data.author.firstName, last: data.author.lastName },
          og_id: data.author.opengovId
        } as IUser)
      : {},
    folder: data.folder
      ? {
          id: data.folder.id,
          publicationId: data.folder.publicationId,
          publication: data.folder.publication,
          title: data.folder.title
        }
      : {}
  } as IStory;
};

export const buildPaginationOutput = (
  page: number,
  count: number,
  resource: IGetStoryGraphqlResponse[]
): IStoryListing => {
  return {
    currentPage: page,
    data: resource.map(processStoryOrTemplate),
    storiesUrl: OpenGovAppConfig.STORIES_URL,
    total: count
  } as IStoryListing;
};
